import React from 'react';

const ChartComponent = ({ chartData }) => {
	return (
	  <div className="l-grid__row justify-content-center">
		<div className="l-grid__column-large-8 l-grid__column-medium-10 u-text-align-center">
		  <div className="l-grid__row u-margin-m circle-chart" data-chart={JSON.stringify(chartData)}>
			<div className="chart-wrapper l-grid__column-large-6 l-grid__column-medium-6"></div>
			<div className="pie-legends l-grid__column-large-6 l-grid__column-medium-6 u-flex"></div>
		  </div>
		</div>
	  </div>
	);
  };

  export default ChartComponent;